import { Grid, Divider } from "@material-ui/core";
import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import I8ln from "../../../i18n/utils";
import logo from "../../assets/icons/cfa.png";
import avatar from "../../assets/icons/avatar-dots.svg";
import "./topNavBar.scss";
import {
  UncontrolledTooltip,
  UncontrolledPopover,
  Card,
  CardBody,
} from "reactstrap";
import I18n from "../../../i18n/utils";
import { getOktaUser } from "../../utils/LocalStorage";
import { useOktaAuth } from "@okta/okta-react";

const TopNavBar: React.FC = (): JSX.Element => {
  const { oktaAuth } = useOktaAuth();
  const history = useHistory();
  const oktaUserInfo = getOktaUser();
  const [openAvatarMenu, setOpenAvatarMenu] = useState<boolean>(false);

  const navigateToHome = () => {
    if (history.location.pathname === "/") {
      window.location.reload();
    } else {
      history.push("/");
    }
  };

  const signOut = async () => {
    await oktaAuth.signOut({}).catch((err: any) => {
      console.log(err);
    });
  };

  const toggleAvatarPopover = () => {
    setOpenAvatarMenu(!openAvatarMenu);
  };
  return (
    <Grid container className={"topNavBar"}>
      <Grid item xs={2} sm={1}>
        <img
          id="logoTooltip"
          src={logo}
          width="35"
          height="35"
          className="nav-app-logo"
          alt={I8ln.t("APP_LOGO_ALT_TEXT")}
          onClick={() => navigateToHome()}
        />
      </Grid>
      <Grid item xs={true}>
        <span className={"topNavBarAppName"} onClick={() => navigateToHome()}>
          {I8ln.t("APP_NAME")}
        </span>
      </Grid>
      <Grid item xs={3} sm={4} className={"topNavBarEnd"}>
        <Grid item>
          <img
            alt=""
            id="avatar-popover"
            className="nav-avatar"
            width="30"
            height="30"
            src={avatar}
            onClick={() => toggleAvatarPopover()}
          />
          <UncontrolledTooltip placement="bottom-end" target="avatar-popover">
            {I18n.t("APP_PROFILE_TOOLTIP")}
          </UncontrolledTooltip>
          <UncontrolledPopover
            placement="bottom-end"
            trigger="legacy"
            isOpen={openAvatarMenu}
            target="avatar-popover"
            toggle={() => toggleAvatarPopover()}
          >
            <Card className="nav-avatar-menu">
              <CardBody>
                <h3 className="nav-avatar-name">{oktaUserInfo[0]}</h3>
                <h4 className="nav-avatar-email">{oktaUserInfo[1]}</h4>
                <Divider variant="middle" className={"divider"} />
                <a onClick={() => signOut()}>{I18n.t("APP_MENU_SIGN_OUT")}</a>
              </CardBody>
            </Card>
          </UncontrolledPopover>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default TopNavBar;
